import Axios from 'axios';

const API_URL = process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3/data/products/akads'

class AkadSyariah {
  index() {
    return Axios.get(API_URL + 'akadsyariah-list');
  }
  indexv3(){
    return Axios.get(API_URL_V3 + '');
  }

  show(akadsyariah) {
    return Axios.get(API_URL + `akadsyariah/${akadsyariah}`);
  }
}

export default new AkadSyariah();



// WEBPACK FOOTER //
// ./src/api/akadsyariah.js